module.exports = __webpack_public_path__ + "img/icon_nxzs.84cade0.png";